import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchModuleDetails = (moduleId: string, setModule: Function, setLoaded: Function, language: string) => {
  ApiService.get(`modules/${moduleId}?get_module_details=true`)
    .then((response) => setModule(response.data.module))
    .catch((err) => {
      console.error("Error while loading module:", err);
      alert(translate(language, "PAGES.MODULE.ERROR.FETCH_MODULE"));
    })
    .finally(() => setLoaded(true));
};

export const fetchModuleExercises = (
  moduleId: string,
  setExercises: Function,
  setExercisesLoaded: Function,
  language: string
) => {
  ApiService.get(`modules/${moduleId}/exercises?get_exercises_details=true`)
    .then((response) => setExercises(response.data.module_exercises))
    .catch((error) => {
      console.error("Error while loading module exercises:", error);
      alert(translate(language, "PAGES.MODULE.ERROR.FETCH_MODULE_EXERCISES"));
    })
    .finally(() => setExercisesLoaded(true));
};

export const getDifficultyColor = (level: number) => {
  if (level <= 3) return "bg-success text-white";
  if (level <= 6) return "bg-secondary text-white";
  if (level <= 8) return "bg-warning text-dark";
  return "bg-danger text-white";
};

export const editModuleExercises = (moduleId: string, exerciseIds: number[], onSuccess: Function, language: string) => {
  ApiService.put(`modules/${moduleId}/exercises`, { exercise_ids: exerciseIds })
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Error while editing module exercises:", error);
      alert(translate(language, "PAGES.MODULE.ERROR.EDIT_MODULE_EXERCISES"));
    });
};

export const fetchModuleEvaluations = (
  moduleId: string,
  setEvaluations: Function,
  setEvaluationsLoaded: Function,
  language: string
) => {
  ApiService.get(`modules/${moduleId}/evaluations?get_evaluations_details=true`)
    .then((response) => setEvaluations(response.data.module_evaluations))
    .catch((error) => {
      console.error("Error while loading module evaluations:", error);
      alert(translate(language, "PAGES.MODULE.ERROR.FETCH_MODULE_EVALUATIONS"));
    })
    .finally(() => setEvaluationsLoaded(true));
};
